<template>
  <Modal
    :title="title"
    :show.sync="forms.showUpd"
    @cancel="forms.showUpd = false"
    @submit="Save"
  >
    <div class="form-inline" style="width:400px; min-height:200px">
      <a style="font-weight:bold;">{{ forms.NamaPerusahaan }}</a>
      <div style="font-size:small; margin-bottom:10px;">
        {{ forms.NamaPotensi }}
      </div>
      <DatePicker label="Mulai Sewa" disabled :value.sync="forms.MulaiSewa" />
      <DatePicker label="Akhir Sewa" disabled :value.sync="forms.AkhirSewa" />
      <Input label="Harga" type="number" :value.sync="forms.Harga" />
      <Input label="ID-Billing" :value.sync="forms.BuktiBayar" />
    </div>
  </Modal>
</template>
<script>
export default {
  data: () => ({}),
  props: {
    forms: Object,
  },
  computed: {
    title() {
      return 'PENERIMAAN'
    },
  },
  methods: {
    async Save() {
      let ret = await this.$api.call('AST.SavPenerimaan', this.forms)
      if (ret.success) {
        this.forms.showUpd = false
        this.$emit('reload')
      }
    },
  },
}
</script>
